import { appEventTypes } from "@src/common/events/AppEventTarget";
import { ImpersonatedUserData } from "@src/common/helpers/impersonatedUser";

interface ImpersonateEventDetail {
  impersonatedUser: ImpersonatedUserData | null;
}

class ImpersonateEvent extends CustomEvent<ImpersonateEventDetail> {
  constructor(impersonatedUser: ImpersonatedUserData | null) {
    super(appEventTypes.IMPERSONATE, {
      detail: {
        impersonatedUser,
      },
    });
  }
}

export default ImpersonateEvent;
